module.exports = __webpack_public_path__ + "static/media/photo298.0a6ed0e4.jpg";